import BaseService from '../../base/base_service';
import IOverlayManager from './overlay_manager_service_interface';

class OverlayManagerService extends BaseService implements IOverlayManager{
  static CLASS: string = 'OverlayManagerService';
  

  init(params) {
    super.init(params);
  }

  /**
   * This property is true if any overlay is opened in orbit by overlay.service.tsx
   */
  public orbitActiveOverlayExists: boolean = false;
  public setOrbitActiveOverlayExists(value: boolean) {
    this.orbitActiveOverlayExists = value;
  }

}

export default OverlayManagerService;
